<!-- NoticeDialog.vue -->
<template>
  <v-dialog :model-value="modelValue" max-width="760px" @update:modelValue="onDialogModelUpdate">
    <v-card>
      <DialogTitleBar>
        {{ noticeTitle }}
        <template #actions>
          <v-btn icon variant="text" aria-label="닫기" @click="close">
            <svg-icon type="mdi" :path="icons.mdiClose" />
          </v-btn>
        </template>
      </DialogTitleBar>

      <v-card-text class="notice-body">
        <div v-if="notice" class="notice-markdown" v-html="renderedBody"></div>
        <p v-else class="notice-empty">현재 표시할 공지사항이 없습니다.</p>
      </v-card-text>

      <v-card-actions class="custom-card-actions">
        <v-btn variant="text" :disabled="!notice" @click="dontShowForWeek">1주일 동안 열지 않음</v-btn>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="close">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogTitleBar from '@/components/DialogTitleBar.vue';
import icons from '@/icons';
import { getFutureKstDateString } from '@/utils/appHelpers';
import { getNoticeSuppressionKey, renderNoticeMarkdown } from '@/utils/noticeHelpers';

export default {
  components: {
    DialogTitleBar,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    notice: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      icons,
    };
  },
  computed: {
    noticeTitle() {
      return this.notice?.title || '공지사항';
    },
    renderedBody() {
      return renderNoticeMarkdown(this.notice?.bodyMarkdown || '');
    },
  },
  methods: {
    onDialogModelUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    close() {
      this.$emit('update:modelValue', false);
    },
    dontShowForWeek() {
      if (!this.notice?.id) {
        this.close();
        return;
      }

      const dateString = getFutureKstDateString(7);
      localStorage.setItem(getNoticeSuppressionKey(this.notice.id), dateString);
      this.close();
    },
  },
};
</script>

<style scoped>
.notice-body {
  padding-top: 4px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.96rem;
}

.notice-empty {
  margin: 0;
  color: rgba(0, 0, 0, 0.64);
}

.notice-markdown :deep(p) {
  margin: 0 0 10px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.72);
}

.notice-markdown :deep(p:last-child) {
  margin-bottom: 0;
}

.notice-markdown :deep(ul) {
  margin: 0 0 10px;
  padding-left: 20px;
}

.notice-markdown :deep(li) {
  margin-bottom: 6px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.72);
}

.notice-markdown :deep(strong) {
  color: rgba(0, 0, 0, 0.82);
  font-weight: 700;
}

.notice-markdown :deep(a) {
  color: #0d5fe5;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.custom-card-actions {
  margin-top: -12px !important;
}

@media (min-width: 601px) {
  .notice-body {
    padding: 0 16px 8px;
    font-size: 0.875rem;
  }

  .notice-markdown :deep(p) {
    margin-bottom: 6px;
    line-height: 1.38;
  }

  .notice-markdown :deep(ul) {
    margin-bottom: 6px;
    padding-left: 18px;
  }

  .notice-markdown :deep(li) {
    margin-bottom: 2px;
    line-height: 1.38;
  }

  .custom-card-actions {
    min-height: 44px;
    padding: 4px 8px;
    margin-top: -8px !important;
  }
}

@media (max-width: 600px) {
  .notice-body {
    padding-left: 4px;
    padding-right: 4px;
  }

  .notice-markdown :deep(ul) {
    padding-left: 16px;
  }
}
</style>
